<template>

    <!-- pricing -->
    <div class="TQ_font_SecularOne TQ_padding_8px TQ_bg_white TQ_borderBox" v-if="!uds_newSubscriptionInfo_c">

        <!-- title -->
        <h2 class="TQ_text_20px TQ_text_capitalize">{{ass_strings.twoWords_paymentPlan[store_system_langCode_ve.val]}}</h2>

        <!-- choose month/yearly payment -->
        <div class="TQ_padding_16px TQ_center TQ_direction_rtl">
            <div class="TQ_inline TQ_verticalAlignMiddle TQ_padding_4px TQ_borderRadius_right TQ_bg_gray4 TQ_box_shadow TQ_width_140px TQ_clickable" :class="!annuallyBilling_b && 'TQ_bg_purple_lite'" @click="annuallyBilling_b=false">
                {{ass_strings.twoWords_monthlyBilling[store_system_langCode_ve.val]}}</div>
            <div class="TQ_inline TQ_verticalAlignMiddle TQ_padding_4px TQ_borderRadius_left  TQ_bg_gray4 TQ_box_shadow TQ_width_140px TQ_clickable" :class="annuallyBilling_b && 'TQ_bg_purple_lite'" @click="annuallyBilling_b=true">
                {{ass_strings.twoWords_yearlyBilling[store_system_langCode_ve.val]}}</div>
            <div class="TQ_inline TQ_verticalAlignMiddle TQ_padding_8px">{{ass_strings.sentence_save20subPlan[store_system_langCode_ve.val]}}</div>
        </div>

        <!-- pricing table  -->
        <div class="TQ_scrollable_horizontal">
            <table class="TQ_center lc_pricingTable">

                <!-- title -->
                <tr>
                    <!-- sapce -->
                    <td></td>

                    <!-- sapce -->
                    <td class=""></td>

                    <!-- value -->
                    <td v-for="(pricingPlan_o, index_n) in pricingPlans_ao" :key="index_n">

                        <div v-if="pricingPlan_o.type_e" class="TQ_padding_8px TQ_margin_0_2px TQ_width_140px TQ_text_capitalize" :style="{background : pricingPlan_o.color_s + '60'}">
                            <div>
                                {{pricingPlan_o.type_e}}
                            </div>
                        </div>
                    </td>
                </tr>

                <!-- images -->
                <tr>
                    <td></td>

                    <td class=""></td>

                    <td v-for="pricingPlan_o in pricingPlans_ao" >

                        <div v-if="pricingPlan_o.maze_r" class="TQ_padding_16px TQ_margin_0_2px" :style="{background : pricingPlan_o.color_s + '55'}">
                            <tq-image :pb_src_r="pricingPlan_o.maze_r"
                                      class="TQ_width_60px TQ_margin_top_8px "/>
                        </div>
                    </td>
                </tr>

                <!-- monthly cost-->
                <tr>

                    <!-- title -->
                    <td >
                        <div class="TQ_bg_gray4 TQ_padding_8px TQ_width_140px TQ_borderBox TQ_align_initial" :style="annuallyBilling_b && 'line-height: 46px'">
                            {{ass_strings.twoWords_monthlyCost[store_system_langCode_ve.val]}}
                        </div>
                    </td>

                    <!-- space-->
                    <td ></td>

                    <!-- table -->
                    <td v-for="(pricingPlan, index_n) in pricingPlans_ao" :key="index_n">
                        <div class="TQ_padding_8px TQ_margin_0_2px" :style="{background : pricingPlan.color_s + '44'}">
                            <div v-if="enum_subPlan_costDollars[pricingPlan.type_e]>-1">

                                <div v-if="annuallyBilling_b" >
                                    {{ (enum_subPlan_costDollars[pricingPlan.type_e] / 100) * 80}} למשחק
                                </div>
<!-- 
                                <div v-if="annuallyBilling_b" class="TQ_text_14px">
                                    ({{ass_strings.oneWord_annually[store_system_langCode_ve.val]}} - {{m_calcMonthlyCost_fn(pricingPlan.type_e)*gv_numbers.monthsInYear}} ₪)
                                </div> -->

                                <div :class="annuallyBilling_b && 'TQ_text_lineThrough TQ_text_14px TQ_textColor_red'">
                                    {{ enum_subPlan_costDollars[pricingPlan.type_e]}} למשחק
                                </div>
                            </div>

                            
                            <div v-else :style="annuallyBilling_b && 'line-height: 46px'">
                                {{ass_strings.oneWord_custom[store_system_langCode_ve.val]}}
                            </div>
                        </div>
                    </td>
                </tr>

                <!-- active Quests-->
                <tr>

                    <!-- title -->
                    <td>
                        <div class="TQ_align_initial TQ_bg_gray4 TQ_padding_8px">
                            {{ass_strings.twoWords_activeQuests[store_system_langCode_ve.val]}}
                        </div>
                    </td>

                    <!-- space -->
                    <td ></td>

                    <!-- value -->
                    <td v-for="(pricingPlan, index_n) in pricingPlans_ao" class="" :key="index_n">
                        <div class="TQ_padding_8px TQ_margin_0_2px" :style="{background : pricingPlan.color_s + '22'}">
                            <!-- first -->
                            <span v-if="index_n===0">1 -  {{ enum_subPlan_activeQuests[pricingPlan.type_e]}}</span>
                            <!-- last -->
                            <span v-else-if="index_n===pricingPlans_ao.length-1"> {{enum_subPlan_activeQuests[pricingPlan.type_e]}}+</span>
                            <!-- middle -->
                            <span v-else>{{ enum_subPlan_activeQuests[pricingPlans_ao[index_n-1].type_e] + 1}} -  {{ enum_subPlan_activeQuests[pricingPlan.type_e]}}</span>
                        </div>
                    </td>
                </tr>

                <!-- old -->
                <div v-if="false">
                    <!-- monthly Players -->
                    <tr v-if="false">
                        <!-- title -->
                        <td>
                            <div class="TQ_align_initial TQ_bg_gray4 TQ_padding_8px" >
                                {{ ass_strings.twoWords_monthlyDevices[store_system_langCode_ve.val] }}
                            </div>
                        </td>
                        <td ></td>

                        <td v-for="(pricingPlan, index_n) in pricingPlans_ao" class="" :key="index_n">
                            <div  class="TQ_padding_8px TQ_margin_0_2px" :style="{background : pricingPlan.color_s + '33'}">
                                {{enum_subPlan_players[pricingPlan.type_e] > 0 ? enum_subPlan_players[pricingPlan.type_e] : ass_strings.oneWord_custom[store_system_langCode_ve.val]}}
                            </div>
                        </td>
                    </tr>

                    <!-- monthly Events -->
                    <tr v-if="false">

                        <!-- title -->
                        <td>
                            <div class="TQ_align_initial TQ_bg_gray4 TQ_padding_8px">
                                {{ass_strings.twoWords_monthlyEvents[store_system_langCode_ve.val]}}
                            </div>
                        </td>
                        <td ></td>

                        <td v-for="pricingPlan in pricingPlans_ao" class="">

                            <div class="TQ_padding_8px TQ_margin_0_2px" :style="{background : pricingPlan.color_s + '11'}">
                                {{enum_subPlan_events[pricingPlan.type_e] > 0 ? enum_subPlan_events[pricingPlan.type_e] : ass_strings.oneWord_unlimited[store_system_langCode_ve.val]}}
                            </div>
                        </td>
                    </tr>

                </div>
         
                <!-- actions
                <tr >
                    <!-- title 
                    <td></td>
                    <td ></td>

                    <td v-for="pricingPlan_c in pricingPlans_ao" >
                        <div class="TQ_padding_8px TQ_margin_8px TQ_width_60px TQ_box_shadow TQ_clickable TQ_text_16px TQ_bg_purple_lite TQ_borderRadius TQ_inline"
                             v-if="p_ud_subscriptionPlan_c && pricingPlan_c.type_e !== p_ud_subscriptionPlan_c.udsspi_m_subscriptionPlan_e()"
                             @click="m_chooseSubPlan_f(pricingPlan_c.type_e)">
                            {{ass_strings.oneWord_select[store_system_langCode_ve.val]}}
                        </div>
                    </td>
                </tr> -->


            </table>
        </div>

    </div>

    <!-- billing info -->
    <div v-else class="TQ_padding_8px">

        <!-- title -->
        <div class="TQ_padding_8px TQ_text_20px TQ_font_SecularOne">
            {{!co_subscribeToLowerPlan_b ? ass_strings.twoWords_paymentInfo[store_system_langCode_ve.val] : ass_strings.twoWords_paymentPlan[store_system_langCode_ve.val]}}
        </div>
        <hr>

        <!-- info table -->
        <div class="TQ_padding_8px">

            <table class="TQ_table TQ_width_100p">
                <tr class="TQ_text_bold TQ_bg_gray4">
                    <td>{{ ass_strings.oneWord_plan[store_system_langCode_ve.val]}}</td>
                    <td>{{ ass_strings.twoWords_activeQuests[store_system_langCode_ve.val]}}</td>
                    <td>{{ ass_strings.twoWords_monthlyEvents[store_system_langCode_ve.val]}}</td>
                    <td>{{ ass_strings.twoWords_monthlyDevices[store_system_langCode_ve.val] }}</td>
                    <td>{{ ass_strings.oneWord_cost[store_system_langCode_ve.val]}}</td>
                </tr>
                <tr>
                    <td class="TQ_text_capitalize">{{uds_newSubscriptionInfo_c && uds_newSubscriptionInfo_c.udsspi_m_subscriptionPlan_e()}} </td>
                    <td>{{ uds_newSubscriptionInfo_c.udsspi_maxQuests_n }}</td>
                    <td>{{ uds_newSubscriptionInfo_c.udsspi_maxEvents_n > 0 ? uds_newSubscriptionInfo_c.udsspi_maxEvents_n : ass_strings.oneWord_unlimited[store_system_langCode_ve.val] }}</td>
                    <td>{{ uds_newSubscriptionInfo_c.udsspi_maxPlayers_n }}</td>
                    <td>{{ format_cost(uds_newSubscriptionInfo_c.udsspi_renewCost_c)}}</td>
                </tr>
            </table>

        </div>
        <hr>

        <!-- more info -->
        <div class="TQ_padding_8px" v-if="!co_subscribeToLowerPlan_b">

            <table class="TQ_text_capitalize TQ_text_20px TQ_align_initial ">
                <tr>
                    <td v-if="!uds_newSubscriptionInfo_c.udsspi_autoRenew_b">{{ ass_strings.twoWords_endAt[store_system_langCode_ve.val] }} </td>
                    <td v-else>{{ ass_strings.twoWords_renewAt[store_system_langCode_ve.val] }} </td>
                    <td class="TQ_padding_4px"></td>
                    <td>{{ co_formatSubscriptionDates_s }}</td>
                </tr>
                <tr>
                    <td>{{ ass_strings.oneWord_cost[store_system_langCode_ve.val] }}  </td>
                    <td class="TQ_padding_4px"></td>
                    <td>
                        <div v-if="initCostCalcEquation" class="TQ_direction_ltr TQ_inline">{{initCostCalcEquation}} </div>
                        <div v-if="initCostCalcEquation" class="TQ_inline TQ_padding_4px"> = </div>
                        <div class="TQ_inline TQ_text_bold"> {{format_cost(uds_newSubscriptionInfo_c.udsspi_initCost_c)}}</div>
                    </td>
                </tr>
            </table>

            <div class="TQ_align_initial TQ_margin_top_8px TQ_text_20px">
                <tq-checkbox class="TQ_width_20px TQ_inline TQ_verticalAlignMiddle"
                             @click.native="uds_newSubscriptionInfo_c.udsspi_autoRenew_b = !uds_newSubscriptionInfo_c.udsspi_autoRenew_b"
                             :p_checked_b="uds_newSubscriptionInfo_c.udsspi_autoRenew_b"/>
                <div class="TQ_padding_4px TQ_inline TQ_verticalAlignMiddle"></div>
                <div class="TQ_inline TQ_verticalAlignMiddle">
                    {{ ass_strings.twoWords_autoRenew[store_system_langCode_ve.val]}}
                </div>
            </div>
        </div>
        <hr v-if="!co_subscribeToLowerPlan_b">

        <!-- credit cards -->
        <div class="TQ_padding_8px" v-if="!co_subscribeToLowerPlan_b">

            <div v-if="!selectedCreditCard">
                <div>
                    {{ass_strings.threeWords_chooseCreditCard[store_system_langCode_ve.val]}}
                </div>
                <tq-credit-cards-list :p_current-user-data_c="p_currentUser_c"

                                      :p_uds_credit-cards_by-id_c="p_uds_creditCards_byId_c"
                                      :pe_click-credit-card_f="(creditCard_c) => selectedCreditCard = creditCard_c"/>
            </div>

            <div v-else class="TQ_padding_8px">
                <tq-on-top-container class="TQ_center " width="fit-content"  >

                    <div slot="topRight" class="TQ_inline TQ_clickable" @click="selectedCreditCard=null">
                        <tq-image :pb_src_r="ass_img_closeRed" class="TQ_width_28px"/>
                    </div>

                    <div slot="body" class="TQ_inline ">
                        <tq-credit-card  :p_credit-card_c="selectedCreditCard" :p_system_lang-code_e="store_system_langCode_ve.val"/>
                    </div>

                </tq-on-top-container>

            </div>


        </div>
        <hr v-if="!co_subscribeToLowerPlan_b">

        <!-- continue btn -->
        <div class="TQ_padding_8px TQ_align_end">
            <tq-loader-button :show-loader="showApprovePaymentBtnLoader_b">
                <div v-if="selectedCreditCard || co_subscribeToLowerPlan_b"
                     @click="m_updateSubscriptionPlan_f"
                     class="TQ_bg_purple TQ_padding_8px TQ_box_shadow TQ_inline TQ_box_shadow TQ_borderRadius TQ_text_capitalize TQ_clickable TQ_text_20px TQ_width_140px TQ_center">
                    {{co_subscribeToLowerPlan_b ? ass_strings.oneWord_update[store_system_langCode_ve.val] : ass_strings.twoWords_approvePayment[store_system_langCode_ve.val]}}
                </div>
            </tq-loader-button>
        </div>

    </div>

</template>

<script>
import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
import {store_getStateValue_vo, store_var} from "@/store";
import {
    ass_img_closeRed,
    ass_img_edit_b, ass_img_playersGroup_b,
    ass_img_tickets_b,
    ass_svg_airplane_w, ass_svg_helicopter_b,
    ass_svg_hot_air_balloon_w,
    ass_svg_paper_airplane2_w,
    ass_svg_rocket2_w
} from "@/assets/scripts/Ass_Files";
import TqToggleSwitch from "@/components/basic/TqToggleSwitch";
import {
    enum_costCurrency_n,
    enum_moreInfo_helpersIds_s, enum_serverStatus,
    enum_subPlan_activeQuests, enum_subPlan_costDollars, enum_subPlan_events, enum_subPlan_players,
    enum_subPlans_s, enum_subscriptionTypes
} from "../../../functions/src/shareCode/Share_S_Enum";
import TqMoreInfo from "@/components/basic2/TqMoreInfo";
import TqImage from "@/components/basic/TqImage";
import TqPopup from "@/components/basic/TqPopup";
import {
    FB_Cost,
    FB_UserData,
    FB_UserDataSub_CreditCard,
    FB_UserDataSub_SubscriptionPlanInfo
} from "../../../functions/src/shareCode/Share_S_Classes";
import {gv_numbers} from "../../../functions/src/shareCode/Share_Ass_GlobalVariable";
import {format_cost_s, format_date_YYYY_MM_DD_fs} from "../../../functions/src/shareCode/Share_S_Format";
import TqCreditCardsList from "@/components/unpure/TqCreditCardsList";
import {validator_objClass_fb} from "../../../functions/src/shareCode/Share_S_Validator";
import TqCreditCard from "@/components/unpure/TqCreditCard";
import TqOnTopContainer from "@/components/basic/TqOnTopContainer";
import TqCheckbox from "@/components/basic/TqCheckbox";
import {server_endPoint_subscriptionCharge_fp} from "@/scripts/Server/S_ServerEndPoints";
import TqLoaderButton from "@/components/basic2/TqLoaderButton";
import {notification_notify2} from "@/scripts/S_Notification";
import {date_monthDiff_fn} from "@/scripts/S_Date";

export default {
    name: "TqPricing",
    components: {
        TqLoaderButton,
        TqCheckbox,
        TqOnTopContainer,
        TqCreditCard, TqCreditCardsList, TqPopup, TqImage, TqMoreInfo, TqToggleSwitch},
    props:{
        p_ud_subscriptionPlan_c:{
            require: true,
            type: FB_UserDataSub_SubscriptionPlanInfo
        },
        p_uds_creditCards_byId_c: {
            require: true,
            type: Object,
            validator(obj){
                return validator_objClass_fb(obj, FB_UserDataSub_CreditCard)
            },
        },
        p_currentUser_c:{
            require: true,
            type: FB_UserData
        },
        pe_updateSuccessfully_f:{
            type: Function
        }
    },
    data(){
        return {
            showApprovePaymentBtnLoader_b : false,
            annuallyBilling_b: false,
            selectedCreditCard: undefined,
            autoRenew_b: true,
            uds_newSubscriptionInfo_c : null,
            initCostCalcEquation : null,

            pricingPlans_ao : [
                // {color_s:"#026c45", maze_r: ass_svg_paper_airplane2_w, type_e: enum_subPlans_s.free,      },
                {color_s:"#f9a602", maze_r: ass_svg_hot_air_balloon_w, type_e: enum_subPlans_s.basic,     ads: true},
                {color_s:"#db4437", maze_r: ass_svg_helicopter_b,      type_e: enum_subPlans_s.advanced,  ads: false},
                {color_s:"#3b5998", maze_r: ass_svg_airplane_w,        type_e: enum_subPlans_s.pro,       ads: false},
                {color_s:"#753679", maze_r: ass_svg_rocket2_w,         type_e: enum_subPlans_s.legend,    ads: false},
            ],

            minDaysForSubCurrentMonth: 15,

            // store
            store_system_langCode_ve : store_getStateValue_vo(store_var.system_langCode),

            // server
            server_ud_paymentInfo_c : undefined,

            // imports
            ass_strings : ass_strings,
            gv_numbers : gv_numbers,
            ass_img_tickets_b : ass_img_tickets_b,
            ass_img_edit_b : ass_img_edit_b,
            ass_img_playersGroup_b : ass_img_playersGroup_b,
            ass_img_closeRed : ass_img_closeRed,

            enum_subPlans_s : enum_subPlans_s,
            enum_moreInfo_helpersIds_s : enum_moreInfo_helpersIds_s,
            enum_subPlan_activeQuests : enum_subPlan_activeQuests,
            enum_subPlan_events : enum_subPlan_events,
            enum_subPlan_players : enum_subPlan_players,
            enum_subPlan_costDollars : enum_subPlan_costDollars,

            format_cost : format_cost_s

        }
    },
    computed:{
        co_date_endCurrentMonth_d(){
            let endDate = new Date()
            endDate.setMonth(endDate.getMonth()+1)
            endDate.setDate(0)
            return endDate
        },
        co_date_nextYear_d(){
            let date = new Date()
            date.setMonth(date.getMonth()+13)
            date.setDate(0)
            return date
        },
        co_date_endNextMonth_d(){
            let date = new Date()
            date.setMonth(date.getMonth()+2)
            date.setDate(0)
            return date
        },
        co_formatSubscriptionDates_s(){
            return `${format_date_YYYY_MM_DD_fs(this.co_lastSubDate_d)}`
        },
        co_totalDays_n(){
            const now = new Date()
            return this.co_date_endCurrentMonth_d.getDate() - now.getDate()
        },
        co_lastSubDate_d(){
            if(this.annuallyBilling_b){
                return this.co_date_nextYear_d
            }else if(this.co_totalDays_n <= this.minDaysForSubCurrentMonth){
                return this.co_date_endNextMonth_d
            }else{
                return this.co_date_endCurrentMonth_d
            }
        },
        co_subscribeToLowerPlan_b(){
            return this.uds_newSubscriptionInfo_c.udsspi_m_getPlanLevel_n() < this.p_ud_subscriptionPlan_c.udsspi_m_getPlanLevel_n()
        },
        co_updateOneMonthInYearlySubPlan_b(){
            return this.uds_newSubscriptionInfo_c.udsspi_subscriptionPaymentType_e === enum_subscriptionTypes.monthly
                && this.p_ud_subscriptionPlan_c.udsspi_subscriptionPaymentType_e === enum_subscriptionTypes.yearly
        }

    },
    methods: {
        m_calcMonthlyCost_fn(billingPlan_e){

            const monthlyCostDollar_n = enum_subPlan_costDollars[billingPlan_e]

            if(this.annuallyBilling_b){
                return Math.round(monthlyCostDollar_n * 8 / 10)
            }else{
                return monthlyCostDollar_n
            }
        },
        m_getRelativeMonthlyCostValue_n(costValue_n, newPayment_b){
            const day_n = (new Date()).getDate()

            if(day_n <= 10){
                return costValue_n
            }else if(day_n <= 20){
                return Math.round(costValue_n * 2/3)
            }else{
                if (newPayment_b){
                    return costValue_n
                }else{
                    return Math.round(costValue_n * 1/3)
                }
            }

        },
        m_getRelativeYearlyCost_c(ud_subscriptionPlan_c){
            const monthDiff_n = date_monthDiff_fn(new Date(), new Date(ud_subscriptionPlan_c.udsspi_endSubscription_t))

            return ud_subscriptionPlan_c.udsspi_renewCost_c.c_value_n*monthDiff_n/gv_numbers.monthsInYear
        },

        m_calcInitCost_f(renewSubscriptionCost_c, newSubscriptionType_e){

            this.initCostCalcEquation = null
            let oldRelativeCostValue_c = 0
            let newRelativeCostValue_c = 0

            // 1) old=month, new=month/year
            if(this.p_ud_subscriptionPlan_c.udsspi_subscriptionPaymentType_e === enum_subscriptionTypes.monthly){
                // 1) old=month, new=month
                if(newSubscriptionType_e === enum_subscriptionTypes.monthly){
                    oldRelativeCostValue_c = this.m_getRelativeMonthlyCostValue_n(this.p_ud_subscriptionPlan_c.udsspi_renewCost_c.c_value_n, false)
                    newRelativeCostValue_c = this.m_getRelativeMonthlyCostValue_n(renewSubscriptionCost_c.c_value_n, true)
                // 1) old=month, new=year
                }else{
                    oldRelativeCostValue_c = this.m_getRelativeMonthlyCostValue_n(this.p_ud_subscriptionPlan_c.udsspi_renewCost_c.c_value_n, false)
                    newRelativeCostValue_c = renewSubscriptionCost_c.c_value_n
                }
            // 2) old=year, new=year
            }else if(newSubscriptionType_e === enum_subscriptionTypes.yearly){
                oldRelativeCostValue_c = this.m_getRelativeYearlyCost_c(this.p_ud_subscriptionPlan_c)
                newRelativeCostValue_c = renewSubscriptionCost_c.c_value_n
            // 3) old=year, new=month
            }else{
                oldRelativeCostValue_c = renewSubscriptionCost_c.c_value_n/gv_numbers.monthsInYear
                newRelativeCostValue_c = this.m_getRelativeMonthlyCostValue_n(renewSubscriptionCost_c.c_value_n, true)
            }

            if(oldRelativeCostValue_c){
                this.initCostCalcEquation = `${newRelativeCostValue_c}$ - ${oldRelativeCostValue_c}$`
            }

            return new FB_Cost({
                c_value_n    : newRelativeCostValue_c - oldRelativeCostValue_c,
                c_currency_e : enum_costCurrency_n.DOLLAR
            })
        },

        m_chooseSubPlan_f(plan_e){

            const renewCost_c = new FB_Cost({c_value_n: this.m_calcMonthlyCost_fn(plan_e), c_currency_e : enum_costCurrency_n.DOLLAR})

            if(this.annuallyBilling_b){
                renewCost_c.c_value_n = renewCost_c.c_value_n * gv_numbers.monthsInYear
            }
            const newSubscriptionType_e = this.annuallyBilling_b ? enum_subscriptionTypes.yearly : enum_subscriptionTypes.monthly

            this.uds_newSubscriptionInfo_c = new FB_UserDataSub_SubscriptionPlanInfo({
                udsspi_endSubscription_t        : this.co_lastSubDate_d.getTime(),
                udsspi_maxQuests_n              : enum_subPlan_activeQuests[plan_e],
                udsspi_maxEvents_n              : enum_subPlan_events[plan_e],
                udsspi_maxPlayers_n             : enum_subPlan_players[plan_e],
                udsspi_userId_uid               : this.p_currentUser_c.ud_userId_uid,
                udsspi_initCost_c               : this.m_calcInitCost_f(renewCost_c, newSubscriptionType_e),
                udsspi_renewCost_c              : renewCost_c,
                udsspi_subscriptionPaymentType_e: newSubscriptionType_e ,
            })
        },
        async m_updateSubscriptionPlan_f(){
            this.showApprovePaymentBtnLoader_b =true

            let subscriptionPlan = null

             // 1) reduce payment plan
             if(this.co_subscribeToLowerPlan_b){
                subscriptionPlan = this.p_ud_subscriptionPlan_c //old=now
                subscriptionPlan.udsspi_renewSubscription_c = this.uds_newSubscriptionInfo_c // new=next
                 // reduce plan = dont need to add payment
                 subscriptionPlan.udsspi_initCost_c.c_value_n = 0

            // 2) update month in yearly plan
            }else if(this.co_updateOneMonthInYearlySubPlan_b){
                 subscriptionPlan = this.uds_newSubscriptionInfo_c // new=now
                 subscriptionPlan.udsspi_renewSubscription_c = this.p_ud_subscriptionPlan_c //old=next
             // 3) update plan
            }else{
                subscriptionPlan = this.uds_newSubscriptionInfo_c //new=now
                subscriptionPlan.udsspi_renewSubscription_c = undefined //new=next
            }

            const serverAns_c = await server_endPoint_subscriptionCharge_fp(subscriptionPlan)
            this.showApprovePaymentBtnLoader_b = false

            if(serverAns_c.sa_status_e === enum_serverStatus.success){
                if(this.pe_updateSuccessfully_f){
                    this.pe_updateSuccessfully_f(subscriptionPlan)
                }
                notification_notify2({
                    title_s : ass_strings.oneWord_updated,
                })
            }else{
                notification_notify2({
                    title_s : ass_strings.oneWord_error,
                    text_s : serverAns_c.sa_msg_s
                })
            }


        },
    },

}
</script>

<style scoped lang="scss">
</style>